import React, { useState } from 'react';
import Icon from '../../../../common/components/Icon';
import monitoringService from '../../../../services/monitoringService';
import { getSuggestions } from '../../../../api/searchSuggations';
import SearchResponse from '../components/SearchResponse';
import { t } from 'i18next';

function SearchPanel({ onClose }) {
    const [query, setQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);

    const handleInputChange = (e) => {
        setQuery(e.target.value);
        // Очищаем результаты при изменении текста
        setSearchResults([]);
    };

    const handleSearch = async () => {
        if (query.trim() === '') return;

        try {
            setIsSearching(true);
            
            // Track search
            monitoringService.trackSearch(query).catch(err => {
                console.warn('Failed to track search:', err);
            });
            
            // Get search suggestions/results
            try {
                const results = await getSuggestions(query.trim());
                // API может вернуть массив напрямую или объект с полем announcements
                const announcements = Array.isArray(results) ? results : (results.announcements || []);
                console.log('Search results:', announcements); // Для отладки
                setSearchResults(announcements);
            } catch (error) {
                console.error('Search error:', error);
                setSearchResults([]);
            } finally {
                setIsSearching(false);
            }
        } catch (err) {
            console.error('Search error:', err);
            setIsSearching(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleFilter = () => {
        // Open filter modal or handle filter
        console.log('Filter clicked');
    };

    return (
        <div className="w-full relative">
            <div className="flex items-center gap-3 w-full">
                {/* Search Input */}
                <div className="flex-1 relative flex items-center bg-white rounded-xl px-5 py-4 border border-gray-200 focus-within:border-[#147F26] focus-within:ring-2 focus-within:ring-[#147F26]/20 transition-all">
                    <input
                        type="text"
                        className="flex-1 bg-transparent outline-none text-gray-800 placeholder-gray-400 text-base"
                        placeholder={t('searchPlaceholder')}
                        value={query}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        autoFocus
                    />
                </div>

                {/* Search Button */}
                <button
                    onClick={handleSearch}
                    className="flex-shrink-0 w-14 h-14 bg-white rounded-full border-2 border-[#147F26] flex items-center justify-center hover:bg-[#F9F9F9] transition-colors"
                    aria-label="Search"
                >
                    <Icon src='search' alt='search' className="w-6 h-6 text-[#147F26]" />
                </button>

                {/* Filter Button */}
                <button
                    onClick={handleFilter}
                    className="flex-shrink-0 w-14 h-14 bg-white rounded-full border-2 border-[#147F26] flex items-center justify-center hover:bg-[#F9F9F9] transition-colors"
                    aria-label="Filter"
                >
                    <Icon src='filter' alt='filter' className="w-6 h-6 text-[#147F26]" />
                </button>
            </div>

            {/* Search Results */}
            {searchResults.length > 0 && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl p-4 z-50 max-h-[400px] overflow-y-auto">
                    <SearchResponse announcements={searchResults} />
                </div>
            )}

            {isSearching && (
                <div className="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-2xl p-4 z-50 text-center text-gray-500">
                    {t('loading') || 'Жүктелуде...'}
                </div>
            )}
        </div>
    );
}

export default SearchPanel;